import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  EntryPolicySetting,
  EntryPolicySettingRequest,
} from '../entities/entry-policy-setting.model';

/**
 * `/EntryPolicySetting` (SchoolService) — per-tenant entry/exit policy. `GET`
 * returns the effective policy (the tenant's, or the service defaults) plus
 * `IsDefault`; `PUT` validates and stores the tenant's policy, echoing
 * `IsDefault: false`. Refusals use the 007 envelope (422) whose `message` is
 * already localized — surfaced verbatim, never re-mapped.
 */
@Injectable({ providedIn: 'root' })
export class EntryPolicySettingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<EntryPolicySetting> {
    return this.http.get<EntryPolicySetting>(`${this.baseUrl}/EntryPolicySetting`, {
      withCredentials: true,
    });
  }

  public update(body: EntryPolicySettingRequest): Observable<EntryPolicySetting> {
    return this.http.put<EntryPolicySetting>(`${this.baseUrl}/EntryPolicySetting`, body, {
      withCredentials: true,
    });
  }
}
